module.exports = __webpack_public_path__ + "static/media/WSP-10PA.da1deb25.jpg";